import { reactive } from 'vue';
import type { RouterOptions } from "vue-router";
import { createRouter, createWebHashHistory } from 'vue-router';
import guards from './guards';
import routes from './routes';

const router = createRouter(
  reactive({
    history: createWebHashHistory(),
    routes,
  }) as RouterOptions
);

// 注册导航守卫
guards.before.forEach(router.beforeEach);
guards.after.forEach(router.afterEach);

export default router;
